<app-card
  class="link"
  [class.pending]="isPending"
  [class.active]="isActive"
  style="--spacing: 1rem"
  [routerLink]="getDeviceDetailRoute(device)"
>
  <div class="flex flex-1">
    <app-icon [name]="device.type | icons" />
    <div class="flex-1 flex column align-start gap-1">
      <div class="flex">
        <h3 class="line-clamp">{{ device.name }}</h3>

        @if (device.isFavorite && !hideFavoriteIcon) {
          <app-icon class="color-favorite" name="ic_star_filled" />
        }
      </div>

      <div class="flex gap-2">
        @if (device.isOutOfService) {
          <app-tag class="ml-2" level="disabled">
            {{ "devices.detail.outOfService.label" | translate }}
          </app-tag>
        }
        @if (description) {
          <p>{{ description }}</p>
        } @else {
          <app-power-item
            [powerSource]="device.powerSource"
            [batteryLevel]="device.batteryLevel"
            [size]="IconSize.SM"
          />
        }
      </div>
    </div>

    <div class="right-content">
      @if (device.isActuator) {
        @if (!hideActions) {
          <app-device-action-trigger
            [disabled]="isInteractionDisabled"
            [isActive]="isActive"
            [isPending]="isDevicePending(device)"
            [vertical]="true"
            [transparent]="true"
            (triggerDeviceAction)="onTriggerDeviceAction($event.value)"
          />
        }
      } @else {
        <p class="nowrap">{{ device.lastSeenDate | relativeDate }}</p>
        @if (device.value) {
          <p class="large">
            {{
              device.valueUnit === DeviceValueUnit.PERCENT
                ? (Number(device.value) / 100 | localizedPercent)
                : (device.value | localizedNumber)
            }}
          </p>
          @if (device.valueUnit) {
            <p>
              {{
                LabelConverter.getDeviceValueUnitLabel(device.valueUnit, false)
                  | translate
              }}
            </p>
          }
        }
      }
    </div>
  </div>
</app-card>
